import { api, unwrap } from '../../shared/api/client';
import type { components } from '../../shared/api/schema.gen';

export type TOrgNotificationSettings = components['schemas']['NotificationSettingsResDto'];
export type TNotificationCategoryRow = components['schemas']['NotificationCategoryBreakdownResDto'];
export type TNotificationCell = components['schemas']['NotificationChannelBreakdownResDto'];
export type TNotificationChannel = TNotificationCell['channel'];

export type TNotificationDigest = components['schemas']['NotificationDigestResDto'];
export type TDigestItem = components['schemas']['NotificationDigestItemResDto'];
export type TDigestAction = NonNullable<TDigestItem['action']>;

export const notificationDigest = (): Promise<TNotificationDigest> =>
  unwrap(api.GET('/v1/notifications/digest'));

export const markNotificationsRead = async (ids: string[]): Promise<void> => {
  await unwrap(api.POST('/v1/notifications/read', { body: { ids } }));
};

export const markAllNotificationsRead = async (): Promise<void> => {
  await unwrap(api.POST('/v1/notifications/read-all'));
};

export const orgNotificationSettings = (): Promise<TOrgNotificationSettings> =>
  unwrap(api.GET('/v1/notifications/settings'));

// A PUT that takes a partial patch: only the ticked cells are sent.
export type TOrgMatrixPatch = Record<string, Partial<Record<TNotificationChannel, boolean>>>;

export const saveOrgNotificationSettings = (
  matrix: TOrgMatrixPatch,
): Promise<TOrgNotificationSettings> =>
  unwrap(api.PUT('/v1/notifications/settings', { body: { matrix } }));
